import classNames from "classnames";
import { FieldKiPehchanConfig } from "../types";
import DisplayIcon from "shared/form/core/displayIcon";
import ToolTip from "shared/components/tooltip";
import Size from "shared/enums/Size";
// import { removeHtmlTagsFromString } from "shared/utils";

export default function FieldKiPehchan(props: FieldKiPehchanConfig) {
  if (!props.label) {
    return null;
  }

  return (
    <label
      className={classNames("form_label ptFormLabel", props.additionalClassNames)}
      // following is not used now but if used in future then just uncomment following and send corresponding props
      // title={props.showTitle ? removeHtmlTagsFromString(props.label) : ""}
      htmlFor={props.htmlFor}>
      <div className="ptFormLabel_left">
        {/* display icon if iconUrl is passed */}
        {props.iconUrl && <DisplayIcon iconUrl={props.iconUrl} />}

        {/* label will always be passed and 
               since it could be HTML as in case of dynamic form field so setting as HTML */}
        <span className="ptFormLabel_content">
          <span className="ptFormLabel_labelText" dangerouslySetInnerHTML={{ __html: props.label }} />
          {/* if field is required then we display red asterisk after the field label */}
          {props.required && <span className="form_label--required">*</span>}

          {/* if there is any additionalLabel then that should be displayed in italics */}
          {props.additionalLabel && (
            <i className="ptFormLabel_additionalText">
              <span dangerouslySetInnerHTML={{ __html: props.additionalLabel }} />
            </i>
          )}

          {/* if there is infoLabel present then it should get displayed as info icon and hover the text should get displayed as a tooltip */}
          {props.infoLabel && (
            <ToolTip content={<span dangerouslySetInnerHTML={{ __html: props.infoLabel }} />} size={Size.SMALL} />
          )}
        </span>
      </div>

      <div className="ptFormLabel_right">
        {/* if there is any warning text then it should be displayed separately; since not used in textArea field anywhere so commenting it */}
        {/* {props.warningText && <div className="warningText">{props.warningText}</div>} */}
        {/* any content that should be displayed on right side of the label should be passed in right prop
        this will always be a component or fragement and displayed as it is sent without any modifications */}
        {props.right}
      </div>
    </label>
  );
}
